<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col offset-md="1" offset-lg="2">
        <Container :paddedTopBottom="false">
          <h2>Joey Hensing</h2>
          <p>
            Mijn naam is Joey Hensing en als osteopaat vind ik het belangrijk
            dat iedereen zich welkom, veilig en gehoord voelt. Ik geloof dat een
            goede behandeling begint bij oprechte aandacht voor jou als persoon.
            Daarom neem ik de tijd om naar je verhaal te luisteren en samen te
            kijken naar wat jouw lichaam nodig heeft.
          </p>
          <p>
            Ieder mens is anders en iedere klacht heeft zijn eigen verhaal. Of
            je nu komt met lichamelijke klachten, beperkingen in je beweging of
            gewoon beter in je vel wilt zitten: ik vind het belangrijk om verder
            te kijken dan alleen de klacht. Het lichaam functioneert als één
            geheel en verdient daarom een persoonlijke benadering, afgestemd op
            jouw situatie en behoeften.
          </p>
          <h3>Nascholingen</h3>
          <ul>
            <li>Kinder en babyopleiding</li>
            <li>Fascia as a Sensory and Emotional Organ</li>
            <li>Pijn en het brein / Segmentale interactie en pijn</li>
            <li>Diafragmata en de osteopathische integratie</li>
            <li>Advanced Spinal Manipulation</li>
            <li>Neuro Manipulation: Cranial Nerves</li>
            <li>Fluidic approach to treatment of connective tissue</li>
            <li>Bezig met Total body reflex</li>
          </ul>
          <h3>Doelgroep</h3>
          <ul>
            <li>Lage rugklachten</li>
            <li>Schouder nek klachten</li>
            <li>Uitstraling klachten</li>
            <li>Hoofdpijn/migraine</li>
            <li>Middenrif, long en ademhaling problemen</li>
            <li>Stress gerelateerde klachten</li>
            <li>Darmklachten</li>
          </ul>
        </Container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Container from "../../components/Container.vue";

export default {
  name: "Joey",
  components: { Container }
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 2rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  margin-top: 3rem;
}

h3 {
  font-size: 1.4rem;
  text-transform: uppercase;
  margin-bottom: 0.2rem;
  color: #747769;
}
</style>
